import React from 'react';
import { Card } from 'react-bootstrap-5';
import { OverlayView } from '@react-google-maps/api';

type OverlayCardProps = {
  children: React.ReactNode;
  lat: number;
  lng: number;
  heightOffset: number;
}

export default function OverlayCard({ children, lat, lng, heightOffset }: OverlayCardProps) {
  if (!children) return null;

  const setOffset = (width: number, height: number) => {
    return { x: -(width / 2), y: -(height + heightOffset) };
  };

  return (
    <OverlayView
      getPixelPositionOffset={setOffset}
      mapPaneName={OverlayView.FLOAT_PANE}
      position={{ lat, lng }}
    >
      <Card className="fs-body shadow-lg overflow-hidden" style={{ minWidth: '275px' }}>
        {children}
      </Card>
    </OverlayView>
  );
}
